export const COLOR_OBJECT_DATA = {
  'login-form-background': '#f7f9e8',
  'login-form-registration-button': '#e6ff5a',
};
